<template>
  <div class="page">
    <Header title="加入博世配件优选店" :show-back="true" />
    <!-- <div class="sign-up-content">
      <div class="content-main-img" :style="{ 'paddingBottom': isExpire ? '30px' : '0' }">
        <van-image :src="signUpMainImg" alt="暂无图片" style="width: 100%; height: 100%" fit="contain"></van-image>
      </div>
      <div class="text-center padding-btn-box" v-if="isExpire">
        <van-button v-if="contractStatus === '0'" type="primary" class="btn application-btn"
          @click="applicationNow">立即申请</van-button>
         <van-button v-if="contractStatus === '1' && (verifyStatus === '01' || verifyStatus === '02')" type="primary"
          class="btn pending-review-btn">已签约，请等待审核</van-button>
        <van-button v-if="contractStatus === '1' && verifyStatus === '03' && authorizeStatus === '01'" type="primary"
          class="btn pending-review-btn">已签约，请等待审核</van-button>
        <van-button
          v-if="(contractStatus === '1' || contractStatus === '2') && verifyStatus === '03' && authorizeStatus === '02'"
          type="primary" class="btn approved-btn">BSS维修站(2024.01.01过期)</van-button>
      </div>
      <div class="text-center padding-btn-box" v-else>
        <van-button v-if="contractStatus === '3'" type="primary" class="btn application-btn"
          @click="continueNow">立即续签</van-button>
      </div>
    </div>
    <van-dialog v-model="isShowOverdue" confirmButtonText="立即续签" confirm-button-color="#4E8C96" @confirm="continueNow">
      <div style="text-align: right;margin: 10px 10px 0 0;"> <van-icon name="cross" @click="close()" /></div>
      <div slot="default" class="tip-bss">
        您的BSS已过期,立即续签无需审核即可加入
      </div>
    </van-dialog> -->
  </div>
</template>

<script>
import Header from '@/components/header'
import bssApi from '@/api/bss'
import cartApi from '@/api/cart'

export default {
  components: {
    Header
  },
  data () {
    return {
      signUpMainImg: process.env.VUE_APP_FILE_SERVER + '/static/files/BSS政策介绍.jpg',
      verifyStatus: null, // 签约状态
      contractStatus: '', // 审核状态
      authorizeStatus: '', // 授权状态
      isExpire: false, // 是否过期 如果过期 不展示按钮模块 如果没有过期 展示
      isShowOverdue: false
    }
  },
  mounted () {
    this.verifySigned()
    this.CarnivalSubmit()
  },
  methods: {
    CarnivalSubmit () {
      let that = this
      let wxUserInfo = JSON.parse(localStorage.getItem('userInfo'))
      console.log('wxUserInfo=================', wxUserInfo)
      let data = {
        clientId: wxUserInfo.clientInfo.clientId,
        clientUserId: wxUserInfo.clientInfo.clientUserId,
        activityKey: 'browseBss'
      }
      cartApi.CarnivalSubmit(data).then(ress => {
        console.log('res===', ress)
        let res = ress.data
        if (res.resultData && res.resultData.msg) {
          console.log('res===', res.resultData.msg)
          that.$toast.success(res.resultData.msg)
        }
      })
    },
    verifySigned () {
      bssApi.verifySigned().then(res => {
        const data = res.data
        if (data.resultCode === '0') {
          this.verifyStatus = data.resultData.verifyStatus
          this.contractStatus = data.resultData.contractStatus
          this.authorizeStatus = data.resultData.authorizeStatus
          if (data.resultData.contractStatus === '3') {
            this.isShowOverdue = true
            // this.$dialog.confirm({
            //   confirmButtonText: '立即续签',
            //   showCancelButton: false,
            //   confirmButtonColor: '#4E8C96',
            //   message: '您的BSS已过期,立即续签无需审核即可加入'
            // }).then(() => {
            //   this.isRenewal()
            // }).catch(() => {
            //   console.log('error')
            // })
          } else {
            this.isExpire = true
          }
        }
      })
    },
    close () {
      this.isShowOverdue = false
    },
    applicationNow () {
      bssApi.immediateSigned().then(res => {
        const data = res.data
        if (data.resultCode === '0') {
          const verifyStatus = data.resultData.verifyStatus
          const contractStatus = data.resultData.contractStatus
          const repairFactory = data.resultData.repairFactory
          this.$dialog.confirm({
            confirmButtonText: '我知道了',
            showCancelButton: false,
            confirmButtonColor: '#4E8C96',
            message: repairFactory && repairFactory === '1' ? '抱歉，您不是修理厂用户，无法签约BSS！' : '欢迎加入博世汽车维修网络，成为博世配件优选店的一员。<br /><br />赋能新业态，共创新未来！'
          }).then(() => {
            if (repairFactory && repairFactory === '1') {
              this.$router.push({ name: 'home-main' })
            } else {
              this.verifyStatus = verifyStatus
              this.contractStatus = contractStatus
            }
          }).catch(() => {
            console.log('error')
          })
        }
      })
    },
    continueNow () {
      this.isShowOverdue = false
      this.isRenewal()
    },
    isRenewal () { // 状态过期 是否再续签
      this.isExpire = false
      bssApi.immediateSigned().then(res => {
        const data = res.data
        if (data.resultCode === '0') {
          this.verifyStatus = data.resultData.verifyStatus
          this.contractStatus = data.resultData.contractStatus
          this.authorizeStatus = data.resultData.authorizeStatus
          if (this.contractStatus && this.contractStatus !== '3') {
            this.isExpire = true
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.sign-up-content {
  .content-main-img {
    width: 100%;
    height: auto;
    // padding-bottom: 30px;
  }

  .padding-btn-box {
    width: 100%;
    background: rgba(255, 255, 255, 1);
    height: 45px;
    padding: 16px 0;
    position: fixed;
    bottom: 0;
  }

  .btn {
    width: 343px;
    color: #fff;
    border: none;
  }

  .application-btn {
    background: #4E8C96;
  }

  .pending-review-btn {
    background: #9FCDD5;
  }

  .approved-btn {
    background: #6c6c6c;
  }
}

.tip-bss {
  margin-top: 30px;
  margin-bottom: 30px;
  text-align: center;
}
</style>
